export enum MENU_ITEM_NAMES {
  plans = 'plans',
  benefits = 'benefits',
}
